export const conditionalRowStyles = [
	{
		when: row => row.is_masked,
		style: {
			backgroundColor: "#FFEBE6",
			"&:hover": {
				cursor: "pointer",
				backgroundColor: "#FFBDAD"
			}
		}
	},
	{
		when: row => row.refund_type === 1,
		style: {
			backgroundColor: "#f7fbcf",
			"&:hover": {
				cursor: "pointer",
				backgroundColor: "#f8ffb7"
			}
		}
	},
	{
		when: row => row.refund_type === 2,
		style: {
			backgroundColor: "#C6D2FF",
			"&:hover": {
				cursor: "pointer",
				backgroundColor: "#B2BDE5"
			}
		}
	}
];
export const MAX_IMAGE_UPLOAD_SIZE = 4; // THIS IS IN MB
export const IS_NULL = "IS_NULL";
export const NOT_NULL = "NOT_NULL";

export const EVENT_PLAN = {
	FREE: 1,
	LITE: 2,
	SILVER: 3,
	GOLD: 4,
	CUSTOM: 5
};



export const CAMPAIGN = {
	WHATSAPP: "whatsapp",
	EMAIL: "email"
};